import {animate, animateChild, group, query, style, transition, trigger} from '@angular/animations';

export const routePopupAnimation = trigger('routePopupAnimation', [
  transition('* => *', [
    style({ position: 'relative', 'z-index': '99'}),
    query(
      ':enter, :leave',
      [
        style({
        }),
      ],
      {optional: true},
    ),
    query(
      ':enter',
      [
        style({
          opacity: 0,
          top: '80px'
        }),
      ],
      {optional: true},
    ),
    query(':leave', animateChild(), {optional: true}),
    group([
      query(
        ':enter',
        [
          animate(
            '0.2s cubic-bezier(.64,.01,.81,.36)',
            style({
              opacity: 1,
              top: '60px'
            }),
          ),
        ],
        {optional: true},
      ),
      query(
        ':leave',
        [
          animate(
            '0.2s cubic-bezier(.16,.78,.26,.99)',
            style({
              opacity: 0,
              top: '80px'
            }),
          ),
        ],
        {optional: true},
      ),
    ]),
    query(':enter', animateChild(), {optional: true}),
  ]),
]);




